document.addEventListener('DOMContentLoaded', function () {
    
    if(document.querySelector('.jsEventFilter')){
        const jsEventFilter = document.querySelector('.jsEventFilter');
        const jsEventFilterItem =  jsEventFilter.querySelectorAll('.jsEventFilterItem');
        const jsEventFilterBadge =  jsEventFilter.querySelectorAll('.jsEventFilterBadge');
        const jsEventFilterAside =  jsEventFilter.querySelector('.jsEventFilterAside');

        for (let index = 0; index < jsEventFilterItem.length; index++) {
            let item = jsEventFilterItem[index];
            let itemCategory = item.getAttribute('data-category');
            checkCategory()
            
            function checkCategory(){
                if (window.innerWidth < 992){
                    item.style.order = itemCategory;
                } else{
                    item.style.order = '';
                }
            }

            window.addEventListener('resize', function(){
                checkCategory()
            });
        }

        function showItems(category) {
            
            for (let index = 0; index < jsEventFilterItem.length; index++){
                let item = jsEventFilterItem[index];
                let itemCategory = item.getAttribute('data-category');
                
                if(category == 'all'){
                    item.classList.remove('is-hide')
                    item.classList.add('is-show')
                    jsEventFilterAside.classList.remove('is-last')
                } else{
                    jsEventFilterAside.classList.add('is-last')
                    if(itemCategory == category){
                        item.classList.remove('is-hide')
                        item.classList.add('is-show')
                   
                    } else{
                        item.classList.add('is-hide')
                        item.classList.remove('is-show')
                    }
                }
            }
        }

        for (let index = 0; index < jsEventFilterBadge.length; index++) {
            let button = jsEventFilterBadge[index];
            let buttonCategory = button.getAttribute('data-category');

            button.addEventListener('click', (e) => {
                e.preventDefault()
                removeBadges()
                button.classList.add('is-active')
                removeItems()
                setTimeout( function() { showItems(buttonCategory)}, 0)
            })
        }
        
        function removeItems() {
            for (let index = 0; index < jsEventFilterItem.length; index++){
                let item = jsEventFilterItem[index]
                item.classList.remove('is-show');
            }
        }

        function removeBadges() {
            for (let index = 0; index < jsEventFilterBadge.length; index++){
                let button = jsEventFilterBadge[index]
                button.classList.remove('is-active');
            }
        }
    }
})

window.checkEventCategory = function (){
    const jsEventFilter = document.querySelector('.jsEventFilter');
    const jsEventFilterItem =  jsEventFilter.querySelectorAll('.jsEventFilterItem');
    const jsEventFilterBadge =  jsEventFilter.querySelectorAll('.jsEventFilterBadge');
    const jsEventFilterAside =  jsEventFilter.querySelector('.jsEventFilterAside');

    for (let index = 0; index < jsEventFilterItem.length; index++) {
        let item = jsEventFilterItem[index];
        let itemCategory = item.getAttribute('data-category');
        checkCategory()
        
        function checkCategory(){
            if (window.innerWidth < 992){
                item.style.order = itemCategory;
            } else{
                item.style.order = '';
            }
        }

        window.addEventListener('resize', function(){
            checkCategory()
        });
    }

    function showItems(category) {
        
        for (let index = 0; index < jsEventFilterItem.length; index++){
            let item = jsEventFilterItem[index];
            let itemCategory = item.getAttribute('data-category');
            
            if(category == 'all'){
                item.classList.remove('is-hide')
                item.classList.add('is-show')
                jsEventFilterAside.classList.remove('is-last')
            } else{
                jsEventFilterAside.classList.add('is-last')
                if(itemCategory == category){
                    item.classList.remove('is-hide')
                    item.classList.add('is-show')
            
                } else{
                    item.classList.add('is-hide')
                    item.classList.remove('is-show')
                }
            }
        }
    }

    for (let index = 0; index < jsEventFilterBadge.length; index++) {
        let button = jsEventFilterBadge[index];
        let buttonCategory = button.getAttribute('data-category');

        if(button.classList.contains('is-active')){
            removeBadges()
            button.classList.add('is-active')
            removeItems()
            setTimeout( function() { showItems(buttonCategory)}, 0)
        }
    }

    function removeItems() {
        for (let index = 0; index < jsEventFilterItem.length; index++){
            let item = jsEventFilterItem[index]
            item.classList.remove('is-show');
        }
    }

    function removeBadges() {
        for (let index = 0; index < jsEventFilterBadge.length; index++){
            let button = jsEventFilterBadge[index]
            button.classList.remove('is-active');
        }
    }
}


// window.checkEventCategory()